<template>
  <div class="tooltip-pass-validator">
    <div class="tooltip-pass-validator__container">
      <p class="tooltip-pass__title">
        <slot></slot>
      </p>
      
      <div class="tooltip-pass__validations-wrapper">

        <div class="validation__container">
          <img :src="require(`@/assets/icons/${validations.length ? 'check' : 'check-invalid'}.svg`)" alt="check">
          <p :class="{'valid' : validations.length}">{{ t('tooltip-pass.length') }}</p>
        </div>

        <div class="validation__container">
          <img :src="require(`@/assets/icons/${validations.letters ? 'check' : 'check-invalid'}.svg`)" alt="check">
          <p :class="{'valid' : validations.letters}">{{ t('tooltip-pass.letters') }}</p>
        </div>

        <div class="validation__container">
          <img :src="require(`@/assets/icons/${validations.numbers ? 'check' : 'check-invalid'}.svg`)" alt="check">
          <p :class="{'valid' : validations.numbers}">{{ t('tooltip-pass.numbers') }}</p>
        </div>

        <div class="validation__container">
          <img :src="require(`@/assets/icons/${validations.specialChars ? 'check' : 'check-invalid'}.svg`)" alt="check">
          <p :class="{'valid' : validations.specialChars}">{{ t('tooltip-pass.special-characters') }}</p>
        </div>

      </div>
    </div>

    <span class="tooltip-arrow"></span>
    <span class="tooltip-arrow--shaded"></span>
  </div>
</template>

<script>
import { watch, ref } from "vue"
import {useI18n} from "vue-i18n"

export default {
  props: {
    password: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const {t} = useI18n()
    const validations = ref({
      length: false,
      letters: false,
      numbers: false,
      specialChars: false
    })

    const validatePassword = (password) => {
      const hasNumbers = /\d/
      const hasLetters = /(?=[^A-Za-z]*[A-Za-z])/
      const hasSpecialChars = /(?=.*[^A-Za-z0-9"\\])[^\\"\\]/
      // const hasSpecialChars = /(?=.*[^A-Za-z0-9"])[^"]/


      // Validate length
      validations.value.length = password.length >= 8

      // Validate numbers
      validations.value.numbers = hasNumbers.test(password)

      // Validate letters
      validations.value.letters = hasLetters.test(password)

      // Validate special chars
      validations.value.specialChars = hasSpecialChars.test(password)
    }

    watch(() => props.password, (newPass) => {
      validatePassword(newPass)
    });

    return {
      validations,
      t
    }
  }
}
</script>

<style scoped>
.tooltip-pass-validator {
  width: auto;
  height: auto;
  position: absolute;
  top: calc(100% + 15px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1100;
  display: none;
}
.tooltip-pass-validator__container {
  width: 300px;
  height: auto;
  background-color: var(--white);
  border-radius: 15px;
  position: relative;
  z-index: 2;
  padding: 15px 12px;
  box-shadow: 0px 0px 6px var(--light-gray);
}

.tooltip-arrow,
.tooltip-arrow--shaded {
  position: absolute;
  width: 25px;
  height: 25px;
  background-color: white;
  bottom: calc(100% - 15px);
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  z-index: 3;
}

.tooltip-arrow--shaded {
  z-index: 1;
  box-shadow: 0px 0px 6px var(--light-gray);
}

.tooltip-pass__validations-wrapper {
  width: 90%;
  margin: 0 auto;
}

.tooltip-pass__title {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 8px;
  color: var(--mm-dark) !important;
  font-family: var(--mm-font-basier-circle) !important;
}

.validation__container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 8px;
}

.validation__container:last-child {
  margin: 0 !important;
}

.validation__container img {
  width: 20px;
  height: 20px;
}

.validation__container p {
  margin: 0;
  line-height: 1.2;
  font-size: 14px;
  text-align: left;
  color: #767676 !important;
  font-family: var(--mm-font-basier-circle) !important;
}

.validation__container p.valid {
  color: #1cd897 !important;
}
</style>